function clean(
  value
) {
  return String(
    value ?? ""
  )
    .trim()
    .toLowerCase();
}


function positiveFinite(
  value
) {
  const number =
    Number(value);

  return (
    Number.isFinite(
      number
    ) &&
    number > 0
  )
    ? number
    : null;
}


function customTrimDimensions(
  value
) {
  const match =
    String(value ?? "")
      .trim()
      .match(
        /^(\d+(?:\.\d+)?)\s*(?:x|×)\s*(\d+(?:\.\d+)?)(?:\s*(?:in|inch|inches|mm|cm))?$/i
      );

  if (!match) {
    return null;
  }

  const width =
    positiveFinite(
      match[1]
    );

  const height =
    positiveFinite(
      match[2]
    );

  return (
    width &&
    height
  )
    ? {
        width,
        height,
      }
    : null;
}


function standardTrimDimensions(
  trimSize
) {
  const key =
    clean(
      trimSize
    );

  const inchMatch =
    key.match(
      /^(\d+(?:\.\d+)?)_x_(\d+(?:\.\d+)?)_in$/
    );

  if (inchMatch) {
    const width =
      positiveFinite(
        inchMatch[1]
      );

    const height =
      positiveFinite(
        inchMatch[2]
      );

    if (
      width &&
      height
    ) {
      return {
        width,
        height,
      };
    }
  }

  if (key === "a4") {
    return {
      width: 210,
      height: 297,
    };
  }

  if (key === "a5") {
    return {
      width: 148,
      height: 210,
    };
  }

  return null;
}


export function childrensBookAuthoringPageAspectRatio(
  visualFormat = {}
) {
  const trimSize =
    clean(
      visualFormat
        ?.trimSize
    );

  const orientation =
    clean(
      visualFormat
        ?.orientation
    );

  if (
    ![
      "portrait",
      "landscape",
      "square",
    ].includes(
      orientation
    )
  ) {
    return null;
  }

  let dimensions =
    trimSize ===
      "custom_dimensions"
      ? customTrimDimensions(
          visualFormat
            ?.customTrimSize
        )
      : standardTrimDimensions(
          trimSize
        );

  if (!dimensions) {
    return null;
  }

  let width =
    dimensions.width;

  let height =
    dimensions.height;

  if (
    orientation ===
      "landscape" &&
    height > width
  ) {
    [
      width,
      height,
    ] = [
      height,
      width,
    ];
  }

  if (
    orientation ===
      "square" &&
    Math.abs(
      width - height
    ) > 0.000001
  ) {
    return null;
  }

  const ratio =
    width / height;

  return (
    Number.isFinite(
      ratio
    ) &&
    ratio > 0
  )
    ? ratio
    : null;
}
